import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OAuthTest() {
  const [searchParams] = useSearchParams();
  const [allParams, setAllParams] = useState<Record<string, string>>({});

  useEffect(() => {
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    setAllParams(params);
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-background px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="border border-border bg-background p-8 shadow-sm">
          <h1 className="mb-8 text-2xl font-semibold text-foreground">OAuth Test Page</h1>
          
          <div className="mb-8">
            <h2 className="mb-4 text-base font-semibold text-foreground">Current URL Parameters:</h2>
            {Object.keys(allParams).length > 0 ? (
              <div className="border border-border bg-muted p-4">
                <pre className="text-sm text-foreground">
                  {JSON.stringify(allParams, null, 2)}
                </pre>
              </div>
            ) : (
              <p className="text-muted-foreground">No URL parameters found</p>
            )}
          </div>

          <div className="mb-8">
            <h2 className="mb-4 text-base font-semibold text-foreground">Full URL:</h2>
            <div className="border border-border bg-muted p-4">
              <code className="break-all text-sm text-foreground">
                {window.location.href}
              </code>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="mb-4 text-base font-semibold text-foreground">Test OAuth Flow:</h2>
            <p className="mb-4 text-muted-foreground">
              Use this URL to test your Slack OAuth flow directly:
            </p>
            <div className="mb-4 border border-primary/30 bg-primary/5 p-4">
              <code className="break-all text-sm text-foreground">
                https://slack.com/oauth/v2/authorize?client_id=YOUR_CLIENT_ID&scope=app_mentions:read,chat:write,commands,im:history,im:read,users:read,team:read&redirect_uri=YOUR_SUPABASE_URL/functions/v1/slack-oauth
              </code>
            </div>
            <p className="text-sm text-muted-foreground">
              Replace YOUR_CLIENT_ID with your actual Slack app Client ID and YOUR_SUPABASE_URL with your Supabase project URL
            </p>
          </div>

          <div>
          <h2 className="mb-4 text-base font-semibold text-foreground">Expected OAuth Redirect URL:</h2>
            <div className="border border-emerald-200 bg-emerald-50 p-4">
              <code className="text-sm text-emerald-800">
                YOUR_SUPABASE_URL/functions/v1/slack-oauth
              </code>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">
              Replace YOUR_SUPABASE_URL with your actual Supabase project URL
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
